import React,{ useState,useEffect} from 'react'
import DataTable from '../Components/Molecules/Table/DataTable'

import _ from "lodash";
import {
  CalendarInput,
  FormDropdown,
  FormField,
  FormFieldMail,
  FormTextArea,
} from "../Components/Molecules/FormField/FormField";
import { useFormik } from "formik";
import * as Yup from "yup";
//import Card from "../Components/Atoms/Card/Card";
import { Container, Row, Col, Card, } from 'react-bootstrap';
import ErrorLabel from "../Components/Atoms/ErrorLabel/ErrorLabel";
import thosuandSeparator from "../Helpers/thousandSeparator";
import { Modal, Button, Form } from 'react-bootstrap';
import {
  CancelButton,
  PrimaryButton,
} from "../Components/Atoms/Button/Button";
import RadioButton from "../Components/Atoms/RadioButton/RadioButton";
import { SingleDatePicker } from "../Components/Atoms/SingleDatePicker/SingleDatePicker";
//import styles from "./Dashboard.module.scss";
import HBar from "../Components/Bars/Bars";
import {invite_customer,apply_loan,branch_list,support_ticket_list,get_master_data} from "../Enums/api_constunts"
import {postMethod} from "../Helpers/services"
import { showToast } from "../Components/Atoms/ToastNotifier/ToastNotifier";
import { useSelector } from "react-redux";
import SupportTicketForm from "./SupportTicketForm"
import CustomerDetails from "./CustomerDetails"
import LoanApplicationForm from './loanForm/LoanApplicationForm';
import { FaArrowLeft } from 'react-icons/fa'; 
export default function SupportTicketsList() {

    const [branchList, setBranchList] = useState([])
    const  [selectedRow, setSelectedRow] = useState(null)
    const [OpenForm,setOpenForm] = useState(0)
    const userData = useSelector((state) => state.auth.user);
    const [filterData,setFilterData] = useState({"page":1,"per_page":25,"role_id":[3],"search_string":""}
    )

    const [serviceTypes,setServiceTypes] = useState([])
    const [selectedServiceType, setSelectedServiceType] = useState(null)
    const getMasterData = ()=>{
      let postData = {"categories":["md_service_types"]};
      //values["tenant_id"] = _.get(selectedTenant,"id");
      postMethod(get_master_data,postData).then((res)=>{
        
        if(_.get(res,"result.md_service_types",[])){

          let lst =  _.get(res,"result.md_service_types",[]);
          lst = lst.filter((item)=>item.id!=1)
          setServiceTypes( lst.map((item)=>{ item["label"] =  item["name"];return item}))
          
        }
        
        
      })
    }
    useEffect(()=>{
      getMasterData()
    },[])
      const columnDefs = [
        { headerName: "ID", field: "index" ,width: 80},
        { headerName: "Ticket Id", field: "reference" ,width: 80},
        { headerName: "Subject", field: "subject", minWidth:150},
        { headerName: "Created", field: "created_by_details.name",minWidth:150 },
        { headerName: "Email", field: "created_by_details.email", minWidth:150},
        { headerName: "Contact Number", field: "created_by_details.mobile_no", minWidth:150},
        { headerName: "Created On", field: "created_on",maxWidth:100 },
      
      ];

      columnDefs.push( { headerName: "Actions", field: "actions",maxWidth:10000 },)

      const [isSpinner, setIsSpinner] = useState(false);
      const handleSubmit = (values) => {
        setIsSpinner(true);
        setIsSpinner(true);
        values["tenant_id"] = _.get(selectedTenant,"id");
        values["user_id"] = _.get(selectedRow,"id");
        values["service_type_id"] = _.get(selectedServiceType,"id");
        
        if(_.has(values,"mobile_no") && _.get(values,"mobile_no",false)){
          let mobile_no  = values["mobile_no"].trim()
          if (mobile_no.startsWith("+91-")) {
            
          } else {
            mobile_no = `+91-${mobile_no}`;
          }
          values["mobile_no"] =  mobile_no;

        }
        
          let url = invite_customer
          if(OpenForm==2){
            url = apply_loan
          }
        values["tenant_id"] = _.get(selectedTenant,"id");
        postMethod(url,values).then((res)=>{
          
          showToast("success",_.get(res, "message","Success"))
          setOpenForm(0)
          setIsSpinner(false);
        }).catch ((error)=>{
          showToast("error",_.get(error, "message","Something went wrong!"))
          setIsSpinner(false);

        })
      };

      const [selectedTenant, setSelectedTenant ] = useState(()=>{
        if(_.get(userData, "tenant_details",null) !=null){
            return { ...userData["tenant_details"], "label":userData["tenant_details"]["name"] }
        
          
        }else{
          return null
        }
          
      })
      const getBranchList = ()=>{
        let postData = {
          "search_string": "",
          "page": 1,
          "per_page": 100,
          "created_on": "",
          "created_to": "",
          "sort_by": "id",
          "sort_order": "desc",
          "status_ids": []
        }
        postMethod(branch_list,postData).then((res)=>{
          if(_.get(res, "list.length") >0){
            let list = res["list"].map((item)=>{
              item["label"] =  item["name"]
              
              return item
            });
            setBranchList(list);
          }
          
        })

      }
      useEffect(()=>{
        //if(OpenForm ==1 && _.get(userData,"role_id") ==1){
          getBranchList();
        //}
        
      },[OpenForm])

      /*
      
      {
      "email": "user@example.com",
      "first_name": "string",
      "last_name": "string",
      "mobile_no": "string",
      "experience": 0,
      "profile_image": "string",
      "role_id": 0,
      "tenant_id": 0
    }
      */
    let formData = {
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required")
        .min(2, "Must be at least 2 characters")
        .max(50, "Must be 50 characters or less"),
      first_name: Yup.string()
        .required("First name is required")
        .min(2, "Must be at least 2 characters")
        .max(50, "Must be 50 characters or less"),
      last_name: Yup.string()
        .required("Last name is required")
        .min(1, "Must be at least 2 characters")
        .max(50, "Must be 50 characters or less"),
      mobile_no: Yup.string()
        .required("Mobile number is required")
        .matches(/^[0-9 + -]+$/, "Only numbers are allowed")
        .min(10, "Must be at least 10 characters")
        .max(15, "Must be 15 characters"),
        service_type_id:  Yup.string()
        .matches(/^[0-9]+$/, "Only numbers are allowed")
      
    }
    let initialValues ={
      first_name: "",
      last_name: "",
      email: "",
      service_type_id: "",
      mobile_no: "",
      tenant_id:_.get(selectedTenant,"name","somthing")
      
    }
    if(_.get(userData,"role_id") ==1){
      formData["tenant_id"] = Yup.string()
      .required("Branch is required")
      //.matches(/^[1-9 + -]+$/, "Only numbers are allowed")
      //initialValues["tenant_id"] = _.get(selectedTenant,"name","somthing")
    }

      let formik = useFormik({
        initialValues:initialValues,
        validationSchema: Yup.object(formData),
        onSubmit: handleSubmit,
        validateOnBlur: true,
        validateOnChange: true,
      });

      
      
      const getDetails = (row , type)=>{
        
        formik.setFieldValue("email", _.get(row,"email",""))
        formik.setFieldValue("first_name", _.get(row,"first_name",""))
        formik.setFieldValue("last_name", _.get(row,"last_name",""))
        formik.setFieldValue("mobile_no", _.get(row,"mobile_no",""))
        formik.setFieldValue("experience", _.get(row,"experience",""))
        if(_.get(row,"admin_tenant_details",false)){
          setSelectedTenant(row["admin_tenant_details"])
          formik.setFieldValue("tenant_id", _.get(row,"admin_tenant_details.name",""))
        }
        
        
        // if(type=="APPLY_LOAN"){

        //   setOpenForm(2);
        //   setSelectedServiceType(null)
          
        // }else{
        //   setOpenForm(1)
        // }

        if(type=="SHOW_DETAILS"){
          setSelectedServiceType(null)
          setOpenForm(2)
        }
        setSelectedRow({...row}); 
      
        

      }

      useEffect(()=>{
        if([0,1].indexOf(OpenForm)>-1){
          formik.resetForm();
          setSelectedRow(null);
          setFilterData((data)=>{
            return {...data}
          });
        }
      
      },[OpenForm])
      
      
      return (
        <div>
          <div className="d-flex align-items-center mb-3">
          {OpenForm>0 && <div style={{"cursor":"pointer"}} onClick={()=>{setOpenForm(0)}} className="mr-1000 cursor-pointer arrow"><FaArrowLeft size={20}   /></div>} {/* Back arrow icon */}
          
          <h3> 
           
          { OpenForm==0?"Support Ticket List":OpenForm==1?"Support Ticket List":OpenForm==2?"Ticket Details":OpenForm==3?"Update Ttcket":"" }
          </h3>
          </div>
            <div className={'mt-3'}>
              {[0].indexOf(OpenForm)>-1   && <DataTable loaded_from="SUPPORT_TICKETS_LIST" columnDefs={columnDefs} apiUrl={support_ticket_list} setFilterData={setFilterData} filterData={filterData} setOpenForm={(v)=>{ setOpenForm(1)}} editRow={(item,action_type)=>{getDetails(item,action_type)}} showCreateBtn={[4,5].indexOf(userData?.role_id)>-1} />}
              
          
              { OpenForm ==1 && <>


                <Modal size="lg"  show={ OpenForm ==1} onHide={() => { setOpenForm(0)}} centered>
                  <Modal.Header closeButton>
                      <Modal.Title>
                        Create Ticket
                      </Modal.Title> 
                    </Modal.Header> 

                  <Modal.Body>
                    <SupportTicketForm loaded_from="SUPPORT_TICKETS_LIST" close_me={setOpenForm} selectUser={userData} />
                  </Modal.Body>        
                </Modal>
                
                
              
              </> }

              { OpenForm ==2  && _.get(selectedRow,"id")&& <>
              
                <Modal size="lg"  show={ OpenForm ==2} onHide={() => { setOpenForm(0)}} centered>
                  <Modal.Header closeButton>
                      <Modal.Title>
                        Ticket Details
                      </Modal.Title> 
                    </Modal.Header> 

                  <Modal.Body>
                  
                    
                        
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6 bg-white shadow-lg rounded-lg border">
      {/* Subject Section */}
      <div className="p-4 bg-gray-50 rounded-lg shadow-sm ">
        <h5 className="text-lg font-semibold text-gray-800 mb-2">Subject</h5>
        <p className="text-gray-600">{selectedRow.subject}</p>
      </div>

      {/* Description Section */}
      <div className="p-4 bg-gray-50 rounded-lg shadow-sm ">
        <h5 className="text-lg font-semibold text-gray-800 mb-2">Description</h5>
        <p className="text-gray-600">{selectedRow.description}</p>
      </div>
    </div>


                          
                   
                  </Modal.Body>        
                </Modal>
              
              </> 
              }
              { OpenForm ==3 && _.has(selectedRow,"id") && <>
            
                {OpenForm}
            
            </>}
            { OpenForm ==4 && <>
              {OpenForm}
            </>} 
            </div>
        </div>
      )

}
